module.exports = __webpack_public_path__ + "img/extrefresh.178040c4.svg";